import * as Sentry from '@sentry/react';
import api from 'api';
import { produce } from 'immer';

import getProjectId from 'utils/url/getProjectId';
import setProjectState from 'store/setProjectState';

import store, { IProjectState } from 'store';
import { components } from 'api/types';

type WorkflowSummary = components['schemas']['WorkflowSummary'];

function applyPriority(projectId: string, runId: string, priority: number, updatedUtc?: string) {
  setProjectState(
    projectId,
    produce((state: IProjectState) => {
      const async = state.runDetailsAsyncMap[runId];
      if (async && (async.status === 'SUCCESS' || async.status === 'REFRESH')) {
        async.data.priority = priority;
        if (updatedUtc) async.data.updated_utc = updatedUtc;
      }
    }),
  );
}

export default async function setWorkflowPriority(runId: string, priority: number, yieldRunning = false) {
  const projectId = getProjectId();
  if (!projectId) throw new Error('No project ID');

  const current = store.getState().projectStateMap[projectId]?.runDetailsAsyncMap[runId];
  const previousPriority =
    current && (current.status === 'SUCCESS' || current.status === 'REFRESH') ? current.data.priority : undefined;

  applyPriority(projectId, runId, priority);

  try {
    const summary = await api
      .patch(`projects/${projectId}/workflows/${runId}/priority`, {
        json: { priority, yield_running: yieldRunning },
      })
      .json<WorkflowSummary>();
    applyPriority(projectId, runId, summary.priority, summary.updated_utc);
  } catch (error) {
    if (previousPriority !== undefined) applyPriority(projectId, runId, previousPriority);
    Sentry.captureException(error);
    throw error;
  }
}
